<template>
  <div class="referred">
    <v-card-text>

      <div class="req-list">
        <div class="req-card"  v-for="item in request_items" :key="item.Id">
          <div v-on:click="goToDetail(item)" v-if="item.req_type==null">
            <v-row>
              <v-col cols="8" style="padding: 5px">
                <label style="font-weight: bold">{{item.RequestDate}}</label>

              </v-col>
              <v-col cols="4" class="text-left" style="padding: 5px">
                  <span><v-icon>
                    mdi-attachment
                  </v-icon></span>
              </v-col>
            </v-row>
            <hr>
            <div class="flex-no-wrap justify-space-between">
              <div>

                <div
                  class="req-name"
                  v-text="item.RequestName"
                ></div>

                <span>
                    {{ $t('reqNumber') }}
                    <span style="font-weight: bold">
                    {{ item.RequestCode }}
                    </span>
                  </span>

                <div>
                  <div class="status">{{item.StatusName}}</div>
                </div>
              </div>

            </div>

          </div>
          <div v-if="item.req_type===2">
            <v-row>
              <v-col cols="8" style="padding: 5px">
                <label style="font-weight: bold">{{item.date}}</label>

              </v-col>
              <v-col cols="4" class="text-left" style="padding: 5px">
                {{ $t('offlineReq') }}
              </v-col>
            </v-row>
            <hr>
            <div class="flex-no-wrap justify-space-between">
              <div>

                <div
                  class="req-name"
                >
                  {{item.type_rel.ProductTypeTitle}} {{item.group_rel.name}} {{item.subgroup_rel.name}}
                  {{item.device_model}}
                </div>

                <span>
<!--                    به شماره درخواست-->
<!--                    <span style="font-weight: bold">-->
<!--                    {{ item.RequestCode }}-->
<!--                    </span>-->
                  </span>

                <div>
                  <div class="status" v-if="item.final_status==null">{{ $t('barresiKarshenas') }}</div>
                  <div class="status" style="color:red" v-if="item.final_status!=null">{{ $t('laghvKarshenas') }}</div>
                </div>
              </div>

            </div>

          </div>
          <div v-if="item.req_type===3">
            <v-row>
              <v-col cols="8" style="padding: 5px">
                <label style="font-weight: bold">{{item.date}}</label>

              </v-col>
              <v-col cols="4" class="text-left" style="padding: 5px">
                {{ $t('offlineReq2') }}
              </v-col>
            </v-row>
            <hr>
            <div class="flex-no-wrap justify-space-between">
              <div>
                <div
                  class="req-name"
                >
                  {{item.type_rel.ProductTypeTitle}} {{item.group_rel.name}} {{item.subgroup_rel.name}}
                  {{item.device_model}}
                </div>
                <span>
<!--                    به شماره درخواست-->
                  <!--                    <span style="font-weight: bold">-->
                  <!--                    {{ item.RequestCode }}-->
                  <!--                    </span>-->
                  </span>

                <div>
                  <div class="status" v-if="item.final_status==null">
                    {{ $t('yaftaneKarshenas') }}
                    <v-progress-circular
                      indeterminate
                      color="green"
                      size="20"
                    ></v-progress-circular></div>
                  <div class="status" style="color:red" v-if="item.final_status!=null &&item.final_status.finalize==4 ">{{ $t('karshenasYaftNashod') }}</div>
                  <div class="status" style="color:red" v-if="item.final_status!=null &&item.final_status.finalize==6 ">{{ $t('rejectedReq') }}</div>
                </div>
              </div>
              <v-row>
                <v-col cols="6">
                  <v-btn style="width: 100%" @click="online_to_offline_confirm(item)" small color="primary">{{ $t('submitOfflineReq') }}</v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn style="width: 100%" @click="cancel_request_confirmation(item)" v-if="item.final_status==null"  small color="primary">{{ $t('rejectReq') }}</v-btn>

                </v-col>
              </v-row>
            </div>

          </div>

        </div>

      </div>

      <infinite-loading @infinite="infiniteHandler" v-if="show_loading">
        <div slot="no-more">{{ $t('noInformation') }}</div>
        <template slot="no-results">{{ $t('noResult') }}</template>
        <template slot="spinner">{{ $t('loading') }}</template>

      </infinite-loading>

    </v-card-text>
  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'
  import { bus } from '../../main'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        selected_online_request:{},
        list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        selected_branch: 0,
        request_items: [],
        last_request_items: [],
        show_loading: false,
        page: 0,
        rules: {
          required: value => !!value || this.$t('necessary'),
          fullName: value => value.length <= 30 || this.$t('max30Character'),
          PersianFullName: value => {
            const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
            return pattern.test(value) || this.$t('nameNotFarsi')
          },
          mobile: value => {
            const pattern = /^(\+98|0098|98|0)?9\d{9}$/
            return pattern.test(value) || this.$t('phoneNotCorrect')
          },
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
    },
    watch: {},
    mounted () {
      this.get_final_requests()
      bus.$on('online_to_offline_confirm', (name) => {
        if (name == true) {
          this.online_to_offline(this.selected_online_request)
        }
      })
      bus.$on('cancel_request_confirm', (name) => {
        if (name == true) {
          this.cancel_online_request_by_user(this.selected_online_request)
        }
      })
      bus.$on('online_request_updated', (name) => {
       this.get_final_requests()
      })
    },

    methods: {
      goToDetail (item) {
        // var passing_data = JSON.parse(localStorage.getItem('request_data'));
        // passing_data.cat_id = item_id;
        // localStorage.setItem("request_data",JSON.stringify(passing_data));
        if (item.IsFinalize == 1) {
          this.$router.push({ name: 'ViewRequest', params: { rec_id: item.Id } })
        } else {
          this.$router.push({ name: 'ViewPreRequest', params: { rec_id: item.Id } })
        }
      },
      get_request_address (item) {
        var address = ''
        if (item.CityName != null) {
          address += item.CityName + ' '
        }
        if (item.AreaName != null) {
          address += item.AreaName + ' '
        }
        return address
      },

      online_to_offline_confirm (item) {
        this.selected_online_request = item
        bus.$emit('show_confirm_dialog', [this.$t('offlineReqSubmit'), this.$t('doYouWantOfflineReq'), 'online_to_offline'])
      },
      cancel_request_confirmation (item) {
        this.selected_online_request = item
        bus.$emit('show_confirm_dialog', [this.$t('rejectReq'), this.$t('doYouWantRejectReq'), 'cancel_request'])
      },
      online_to_offline (item) {
        var self = this
        var user_id = localStorage.getItem('userId2')
        const send_data = {
          user_id: user_id,
          reqId: item.id,
        }
        var formData = new FormData()
        formData.append('user_id', user_id)
        formData.append('reqId',  item.id)
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://cp.zoodkomak.com/api/online_to_offline_pwa', formData, {})
          .then(response => {
            if (response.data.error == 0) {
              bus.$emit('show_dialog', [this.$t('reqSubmited'), response.data.msg])
              self.get_final_requests()
            } else {
              bus.$emit('show_dialog', [this.$t('error'), response.data.msg])
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      cancel_online_request_by_user (item) {
        var self = this
        var user_id = localStorage.getItem('userId2')
        const send_data = {
          user_id: user_id,
          reqId: item.id,
        }
        var formData = new FormData()
        formData.append('user_id', user_id)
        formData.append('reqId',  item.id)
        this.axios.post('https://cp.zoodkomak.com/api/cancel_online_request_by_user', formData, {})
          .then(response => {
            if (response.data.error == 0) {
              bus.$emit('show_dialog', [this.$t('reqRejected'), response.data.msg])
              self.get_final_requests()
            } else {
              bus.$emit('show_dialog', [this.$t('error'), response.data.msg])
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_final_requests () {
        this.request_items = []
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          Count: this.page,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetUserPreRequests', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              response.data.requests.forEach(function (number) {
                number.created_at = number.CreatedAt
                self.request_items.push(number)
                // self.last_request_items.push(number);
              })
              self.get_zoodkomak_requests()
              // if(self.first){
              //   self.first = false;
              //   // self.infiniteHandler()
              //
              // }
              // if($state !=null){
              //   if(self.last_request_items.length>0){
              //     console.log("loaded called")
              //     $state.loaded();
              //   }else{
              //     console.log("complete called")
              //
              //     $state.complete();
              //   }
              // }
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_zoodkomak_requests () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          mobile: localStorage.getItem('phone'),
          Count: this.page,
        }
        var formData = new FormData()
        formData.append('UserId', user_id)
        formData.append('mobile', localStorage.getItem('phone'))
        formData.append('Count', this.page)
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://cp.zoodkomak.com/api/get_user_requests', formData, {})
          .then(response => {
            // self.request_items = self.request_items.concat(response.data)
            response.data.data.forEach(function (number) {
              self.request_items.push(number)
              // self.last_request_items.push(number);
            })
            self.request_items.sort(function (a, b) {
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return new Date(b.created_at) - new Date(a.created_at)
            })
            // if(self.first){
            //   self.first = false;
            //   // self.infiniteHandler()
            //
            // }
            // if($state !=null){
            //   if(self.last_request_items.length>0){
            //     console.log("loaded called")
            //     $state.loaded();
            //   }else{
            //     console.log("complete called")
            //
            //     $state.complete();
            //   }
            // }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      infiniteHandler ($state) {
        var self = this
        console.log('first is ' + this.first)
        if (this.first) {
          // $state.loaded();
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        }

        console.log('hiii' + self.last_request_items.length)
        setTimeout(() => {
          // if (self.last_request_items>0 ) {
          self.page += 1
          self.get_pre_requests($state)
          // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
        }, 1000)
      },
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
